import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=46ddd848&scoped=true&"
import script from "./pedidos.vue?vue&type=script&lang=ts&"
export * from "./pedidos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ddd848",
  null
  
)

export default component.exports